module.exports = __webpack_public_path__ + "static/media/YellowJacket514_3c.e157d711.svg";